import React, { FC, useState } from "react";
import { Grid } from "@getregistered/greg-editors";
import { gridLoader } from "../../domain/grid/resultLoader";
import {
  DownloadLink,
  PaginatedApplicationGrid,
} from "./PaginatedApplicationGrid";
import { createRenderCheckinCell } from "./CheckinCell/renderCheckinCell";
import { DEFAULT_PER_PAGE, DEFAULT_PER_PAGE_STORAGE_KEY } from "./constants";
import { RowEditComponent } from "@getregistered/greg-editors/dist/lib/domain/grid/types";
import type { CellRenderFunction } from "@getregistered/greg-editors/dist/lib/GregGrid/PaginatedGrid/types";

export interface ReadOnlyGridProps {
  grid: Grid;
  resultsUrl: string;
  totalsUrl: string;
  downloadLinks?: DownloadLink[];
  RowEditor?: RowEditComponent;
}

export const ReadOnlyGrid: FC<ReadOnlyGridProps> = ({
  grid,
  resultsUrl,
  totalsUrl,
  downloadLinks,
  RowEditor,
}) => {
  const [cacheVersion, setCacheVersion] = useState<number>(1);
  const loader = gridLoader(resultsUrl, totalsUrl, grid.columns);

  const handleReload = () => {
    setCacheVersion(prev => prev + 1);
  };

  const renderCheckinCell = createRenderCheckinCell(handleReload);

  return (
    <PaginatedApplicationGrid
      grid={grid}
      loader={loader}
      defaultPerPage={DEFAULT_PER_PAGE}
      perPageStorageKey={DEFAULT_PER_PAGE_STORAGE_KEY}
      page={1}
      downloadLinks={downloadLinks}
      RowEditor={RowEditor}
      renderCell={renderCheckinCell as any}
      resultsCacheKey={cacheVersion}
    />
  );
};
